import GeneralHeader from './GeneralHeader';

export default GeneralHeader;
